import { Helmet } from 'react-helmet';
import { canonicalUrlCleanup } from '../canonical-url-cleanup';

export interface OpenGraphProps {
    url: string;
    title: string;
    description: string;
    imageUrl?: string;
    type?: string; // defaults to 'website'
}

export const OpenGraph = ({
    url,
    title,
    description,
    imageUrl = undefined,
    type = 'website',
}: OpenGraphProps): JSX.Element => (
    <Helmet>
        <meta property="og:url" content={canonicalUrlCleanup(url)} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        {imageUrl ? <meta property="og:image" content={imageUrl} /> : null}
        <meta property="og:type" content={type} />
        <meta property="og:site_name" content="Sur La Table" />
    </Helmet>
);
